import { runtime } from "../core/runtime.js";

export function primeCompletionAudio() {
  try {
    if (!runtime.studyAudio || runtime.studyAudio.state === "closed") {
      const Audio = window.AudioContext || window.webkitAudioContext;
      if (!Audio) return null;
      runtime.studyAudio = new Audio({ latencyHint: "playback" });
    }
    void runtime.studyAudio.resume().catch(() => {});
    return runtime.studyAudio;
  } catch {
    return null;
  }
}

// A soft three-note resolution, with a light bell overtone and natural decay.
// Keep this reusable for both focus sessions and the daily study sequence.
export function scheduleCompletionChime(
  context,
  destination = context.destination,
  at = context.currentTime,
) {
  [523.251, 659.255, 783.991].forEach((frequency, index) => {
    const onset = at + index * 0.17;
    for (const [multiple, level] of [
      [1, 0.065],
      [2, 0.012],
      [3, 0.003],
    ]) {
      const oscillator = context.createOscillator(),
        gain = context.createGain();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency * multiple, onset);
      gain.gain.setValueAtTime(0, onset);
      gain.gain.linearRampToValueAtTime(level, onset + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, onset + 0.95);
      gain.gain.linearRampToValueAtTime(0, onset + 1.08);
      oscillator.connect(gain).connect(destination);
      oscillator.start(onset);
      oscillator.stop(onset + 1.1);
      oscillator.onended = () => {
        oscillator.disconnect();
        gain.disconnect();
      };
    }
  });
}

export async function playCompletionChime(preview = false) {
  if (!preview && !runtime.state.prefs.sound) return;
  const context = primeCompletionAudio();
  if (!context) return;
  try {
    await context.resume();
    scheduleCompletionChime(context);
  } catch {}
}
